import ReactGA from 'react-ga4';
import { store } from '../../../store';
import { LANGUAGE } from './constants';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

export const trackEventGA4 = ({ category, action, params }) => {
  const state = store.getState();
  const userInfo = state?.userData?.userInfo?.userProfile;

  const eventParams = {
    category,
    language: LANGUAGE.ENGLISH,
    user_id: userInfo?.id || '',
    user_name: userInfo?.name || '',
    user_role: userInfo?.roles?.[0]?.name || '',
    ...params,
  };

  if (params?.page_number !== undefined) {
    eventParams.page_number = params.page_number;
  }
  if (params?.page_count !== undefined) {
    eventParams.page_count = params.page_count;
  }

  ReactGA.event(action, eventParams);
};